var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.headers),function(key,index){return [(key === 'name')?_c('span',{key:index,class:[
                'table__body__row__text position--relative',
                ("table__" + _vm.model + "__col__" + index)
            ]},[_vm._v(" "+_vm._s(_vm.row[key] || '')+" ")]):_c('span',{key:index,class:[
                'position--relative',
                ("table__" + _vm.model + "__col__" + index)
            ]},[_c('span',{class:("row__script__state row__script__state--" + (_vm.row.enabled ? 'active' : 'disabled') + " display--inline-b")})])]}),_c('div',{class:[
            'row__script__actions display--flex',
            ("table__" + _vm.model + "__col__2"),
            { 'row__script__actions--end': _vm.row.enabled || !_vm.$store.getters.can( 'script', 'edit' ) }
        ]},[(!_vm.row.enabled)?_c('table-actions',{attrs:{"settings":{
                model: 'script',
                active: {
                    action: _vm.activeScript
                },
                delete: {
                    action: _vm.deleteScript
                }
            }}}):_vm._e(),_c('router-link',{staticClass:"table__body__row__icon row__script__anchor position--relative accessibility--button",attrs:{"to":("/campaigns/" + (_vm.$route.params.id) + "/scripts/" + (_vm.row.id))}},[_c('icon-info',{staticClass:"row__script__icon"})],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }